import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectCoordinateSystem, selectData, setData } from "../PDFSlice"
import { coordinateSystems, projectionLabel } from "../PDFAnnotations/PDFCoordinateNotations"
import { useEffectUnsafe } from "@nova/use-effect-unsafe"
import { selectUserFullName } from "features/entity-caching/members/UserManagementSlice"
import { formatShortDate } from "@nova/format"

export const useDefaultPDFMetadata = () => {
    const dispatch = useAppDispatch()
    const projection = useAppSelector(selectData("projection"))
    const datum = useAppSelector(selectData("datum"))
    const createdBy = useAppSelector(selectData("createdBy"))
    const createdAt = useAppSelector(selectData("createdAt"))

    const userName = useAppSelector(selectUserFullName())

    const coordinateSystem = useAppSelector(selectCoordinateSystem())
    const currentCoordinateSystem = coordinateSystems[coordinateSystem]

    //setup the default meta data
    useEffectUnsafe(() => {
        const input = currentCoordinateSystem.proj4
        const projMatch = input.match(/\+proj=([^\s]+)/)
        const datumMatch = input.match(/\+datum=([^\s]+)/)

        const derivedProj = projMatch ? projectionLabel(projMatch[1]) : null
        const derivedDatum = datumMatch ? datumMatch[1] : null
        if (derivedProj && !projection) dispatch(setData({ type: "projection", data: derivedProj }))
        if (derivedDatum && !datum) dispatch(setData({ type: "datum", data: derivedDatum }))
        if (userName && !createdBy) {
            dispatch(setData({ type: "createdBy", data: userName }))
        }
        if (!createdAt)
            dispatch(setData({ type: "createdAt", data: formatShortDate({ value: new Date() }) }))
    }, [])
}
